// extracted by mini-css-extract-plugin
export var contentBody = "_bg-9";
export var headerImage = "_bg-2";
export var imageButton = "_bg-7";
export var imageButtonIcon = "_bg-8";
export var imageHeader = "_bg-4";
export var imageHeaderText = "_bg-5";
export var imageOverlay = "_bg-3";
export var imageTitle = "_bg-6";
export var imageWrapper = "_bg-1";
export var taskList = "_bg-a";
export var widget = "_bg-0";